import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { combineLatestWith, filter, map, of, switchMap, take, tap } from 'rxjs';
import { UserPermissionsService } from '../services/user-permissions.service';
import { authSelectors } from '@content-platform/web-angular-shared-util-auth';
import { userPermissionListSelectors } from '../../selectors';
import { userPermissionListActions } from '../../actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../services/user-permissions.service";
import * as i3 from "@angular/router";
const FEATURE_GUARD_DATA_PROPERTY = 'featureGuard';
/**
 * A Guard that actives a route based on if a feature is accessible
 * Use the data property of the route to define the required feature
 * https://stackoverflow.com/a/42721468
 *
 * @example
 *  const routes: Routes = [{
      path: '',
      component: SomeComponent,
      data: {
        featureGuard: {key: 'some_feature'}
      },
      canActivate: [FeatureGuard]
 *  }];
 * @export
 * @class FeatureGuard
 * @implements {CanActivate}
 */
export class FeatureGuard {
    constructor(store, userPermissionService, router) {
        this.store = store;
        this.userPermissionService = userPermissionService;
        this.router = router;
    } // uses the parent class instance actually, but could in theory take any other deps
    canActivate(route) {
        const options = route.data[FEATURE_GUARD_DATA_PROPERTY] || {};
        // checks typical activation (auth) + custom features
        return this.store.pipe(select(authSelectors.getIsLoggedIn), combineLatestWith(this.checkPermissions(options.key)), map(([isLoggedIn, hasFeature]) => isLoggedIn && hasFeature // not allowed if any result is false
        ), tap((allowed) => {
            if (!allowed && !this.router.navigated) {
                // If we haven't navigated yet, this is a deeplink. Redirect to base
                // if we have navigated, just don't allow this navigation (ie. do nothing)
                this.router.navigate(['/']);
            }
        }));
    }
    checkPermissions(featureKey) {
        if (!featureKey) {
            return of(true);
        }
        return this.store.pipe(select(userPermissionListSelectors.getUserPermissionListLoaded), map((permsLoaded) => {
            if (!permsLoaded) {
                this.store
                    .pipe(select(authSelectors.getADUser))
                    .pipe(map((user) => this.store.dispatch(new userPermissionListActions.LoadById(user.profile.oid))));
                return false;
            }
            return true;
        }), filter((loaded) => !!loaded), take(1), switchMap(() => this.userPermissionService.hasFeatureAsync(featureKey)));
    }
    static { this.ɵfac = function FeatureGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FeatureGuard)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.UserPermissionsService), i0.ɵɵinject(i3.Router)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FeatureGuard, factory: FeatureGuard.ɵfac }); }
}
//# sourceMappingURL=feature.guard.js.map